import { render, staticRenderFns } from "./SpeedometerChart.vue?vue&type=template&id=224f48b0"
import script from "./SpeedometerChart.vue?vue&type=script&lang=js"
export * from "./SpeedometerChart.vue?vue&type=script&lang=js"
import style0 from "./SpeedometerChart.vue?vue&type=style&index=0&id=224f48b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports